import React from "react";
import Chart from "react-google-charts";

class LineChart extends React.Component {
    constructor(props) {
        super(props);
        this.chartReference = React.createRef();


    }
    componentDidMount() {
        console.log(this.chartReference); // returns a Chart.js instance reference
    }
    render() {
        
        return (

            
            <React.Fragment>
                <div>
                    
                    <Chart
                        width={'100%'}
                        height={'300px'}
                        chartType="LineChart"
                        loader={<div>Loading Chart</div>}
                        data={this.props.dataLine} options={{
                            title: "TENDENCIA DE CALIFICACIÓN",
                            hAxis: {
                                title: 'FECHA',
                            }, vAxis: {
                                title: 'RESULTADO',
                            },
                        }}
                        rootProps={{ 'data-testid': '1' }}
                    />


                </div>





            </React.Fragment>
        );
    }
}

export default LineChart;
